import { LogoutOutlined, UserOutlined, InfoOutlined } from '@ant-design/icons';
import { Menu } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import { AuthContext } from 'context/auth';
import { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const HeaderMenu = () => {
    const { currentUser, signout } = useContext(AuthContext);
    const navigate = useNavigate();

    const logout = () => {
        signout();
        navigate("/", { replace: true })
    }

    return (
        <Menu
            className='profileMenu'
            mode="horizontal"
            style={{ height: '100%', borderRight: 0, minWidth: '80px', float: 'right' }}
        >
            <SubMenu key="profile" icon={<UserOutlined />} title={`${currentUser?.email}`}>
                <Menu.Item key="user_profile"><NavLink to="/profile"><InfoOutlined /> Profilo</NavLink></Menu.Item>
                <Menu.Item key="user_signout" onClick={() => logout()}><LogoutOutlined /> Logout</Menu.Item>
            </SubMenu>
        </Menu>
    )
}

export default HeaderMenu;